import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { useTranslation } from 'react-i18next';
import { StatusOption } from 'shared/types/general';

interface ChangeOrderStatusParams {
  onSubmit: any;
  status: StatusOption[];
}

function ChangeOrderStatusForm({ onSubmit, status }: ChangeOrderStatusParams) {
  const { t } = useTranslation();

  return (
    <EnhancedForm onSubmit={onSubmit} formId="editOrderStatus" hideControls>
      <IdentityField
        required
        component={AutocompleteAdapter}
        name="status"
        options={status}
        label={t(`entities.order_head.edit-status-label`)}
        optionLabel="display_name"
        optionValue="value"
      />
    </EnhancedForm>
  );
}

export default ChangeOrderStatusForm;
